import type { UsersFilters } from '../types';

/**
 * Query key factory for users feature
 * Follows TanStack Query best practices for key organization
 */
export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (filters: UsersFilters) => [...userKeys.lists(), filters] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
  organisationsInfinite: (search: string) =>
    ['organisations', 'infinite', search] as const,
  organisation: (id: string) => ['organisations', 'detail', id] as const,
  accountSearch: (query: string) => [...userKeys.all, 'accountSearch', query] as const,
  accountByOrganisationId: (organisationId: string) =>
    [...userKeys.all, 'accountByOrganisationId', organisationId] as const,
  newUserOptions: (organisationId: string) => [...userKeys.all, 'newUserOptions', organisationId] as const,
  sessions: (userId: string) => [...userKeys.all, 'sessions', userId] as const,
  securityLog: (userId: string) => [...userKeys.all, 'securityLog', userId] as const,
  roles: () => [...userKeys.all, 'roles'] as const,
};
